module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.773ee130.webp";